import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import Spinner from 'common/components/Spinner';
import { useTranslation } from 'services/localization';
import { RiUploadLine } from 'react-icons/ri';

interface Props {
	onUpload: (file: File) => void;
	loading: boolean;
}
const ImportUpload = (props: Props) => {
	const { t } = useTranslation();

	const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
		const files = e.target.files;
		if (files) {
			const file = files[0];
			props.onUpload(file);
		}
	};

	return (
		<>
			<Typography variant="h6" sx={{ mb: 2 }}>
				{t('inventory.import.uploadFile', 'Upload file')}
			</Typography>
			<Box
				sx={{
					mt: 4,
					width: '100%',
					background: (theme) => theme.palette.background.default,
					textAlign: 'center',
					p: 4,
				}}
			>
				<Button
					component="label"
					variant="contained"
					color="primary"
					startIcon={props.loading ? undefined : <RiUploadLine size={20} />}
					sx={{ px: 3 }}
					disabled={props.loading}
				>
					{props.loading ? (
						<Spinner padding={8} thickness={4} color="inherit" />
					) : (
						t('inventory.import.chooseFile', 'Choose file')
					)}
					<input
						onChange={handleFileUpload}
						style={{ display: 'none' }}
						type="file"
						accept=".csv,.txt"
					/>
				</Button>
				<Typography
					variant="caption"
					color="secondary"
					sx={{ display: 'block', fontWeight: 400, mt: 3 }}
				>
					{t('inventory.import.supportedFormats', 'Supported file formats')}
					{': .csv, .txt'}
				</Typography>
			</Box>
		</>
	);
};

export default ImportUpload;
